/**
 * Application configuration
 * Loads environment variables and provides configuration object
 * 
 * Note: Vite uses import.meta.env for environment variables
 * Variables must be prefixed with VITE_ to be exposed to the client
 */

// Safely access import.meta.env with fallbacks
const getEnv = (key, defaultValue) => {
  // Vite exposes env vars via import.meta.env
  // For backward compatibility, check both VITE_ and REACT_APP_ prefixes
  const viteKey = key.replace('REACT_APP_', 'VITE_');
  if (import.meta.env[viteKey] !== undefined) {
    return import.meta.env[viteKey];
  }
  if (import.meta.env[key] !== undefined) {
    return import.meta.env[key];
  }
  return defaultValue;
};

const config = {
  // API Configuration
  api: {
    baseUrl: getEnv('REACT_APP_API_URL', 'http://localhost:3001'),
    timeout: parseInt(getEnv('REACT_APP_API_TIMEOUT', '10000'), 10),
  },

  // Application Settings
  app: {
    name: getEnv('REACT_APP_NAME', 'Avne Chen'),
    version: getEnv('REACT_APP_VERSION', '1.0.0'),
    environment: import.meta.env.MODE || 'development',
  },

  // Feature Flags
  features: {
    enableHebrewDate: getEnv('REACT_APP_ENABLE_HEBREW_DATE', 'true') !== 'false',
    enableNotifications: getEnv('REACT_APP_ENABLE_NOTIFICATIONS', 'true') !== 'false',
  },

  // External Services
  external: {
    hebcalApi: getEnv('REACT_APP_HEBCAL_API_URL', 'https://www.hebcal.com/converter'),
    shopUrl: getEnv('REACT_APP_SHOP_URL', 'https://avnechen.myshopify.com/'),
  },

  // Google Sheets Integration
  googleSheets: {
    webAppUrl: getEnv('REACT_APP_GOOGLE_SHEETS_WEB_APP_URL', ''),
  },

  // Analytics
  analytics: {
    clarity: {
      projectId: getEnv('REACT_APP_CLARITY_PROJECT_ID', 'uey6tetlqc'),
    },
  },
};

// Add googleSheetsUrl to api config for convenience
config.api.googleSheetsUrl = config.googleSheets.webAppUrl;

export default config;

